var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{attrs:{"for":_vm.id + _vm.value}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.internalSelected),expression:"internalSelected"}],attrs:{"type":"radio","id":_vm.id + _vm.value,"name":_vm.name},domProps:{"value":_vm.value,"checked":_vm._q(_vm.internalSelected,_vm.value)},on:{"change":function($event){_vm.internalSelected=_vm.value}}}),_vm._v("\n\t\t"+_vm._s(_vm.label)+"\n\t")])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./admin/src/js/components/AcRadio.vue